var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50041 5.3125C6.74388 5.3125 5.31276 6.74355 5.31276 8.5C5.31276 10.2564 6.74388 11.6875 8.50041 11.6875C10.2569 11.6875 11.6881 10.2564 11.6881 8.5C11.6881 6.74355 10.2569 5.3125 8.50041 5.3125ZM16.6821 7.98535L13.5376 6.41484L14.6499 3.08125C14.7994 2.62969 14.371 2.20137 13.9227 2.3541L10.589 3.46641L9.01509 0.31875C8.80258 -0.10625 8.19825 -0.10625 7.98574 0.31875L6.41515 3.46309L3.07808 2.35078C2.62649 2.20137 2.19815 2.62969 2.3509 3.07793L3.46325 6.41152L0.318765 7.98535C-0.106255 8.19785 -0.106255 8.80215 0.318765 9.01465L3.46325 10.5852L2.3509 13.9221C2.20147 14.3736 2.62982 14.802 3.07808 14.6492L6.41183 13.5369L7.98242 16.6812C8.19493 17.1063 8.79925 17.1063 9.01177 16.6812L10.5823 13.5369L13.9161 14.6492C14.3677 14.7986 14.796 14.3703 14.6433 13.9221L13.5309 10.5885L16.6754 9.01797C17.1071 8.80215 17.1071 8.19785 16.6821 7.98535ZM11.5054 11.5049C9.84852 13.1617 7.1523 13.1617 5.49538 11.5049C3.83847 9.84805 3.83847 7.15195 5.49538 5.49512C7.1523 3.83828 9.84852 3.83828 11.5054 5.49512C13.1624 7.15195 13.1624 9.84805 11.5054 11.5049Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.9a0e70a259bb82ae0c74e256da77fa55.svg";
export { ForwardRef as ReactComponent };